import { Header, Shared, HomePage } from "./language-map";

const languageRUS = {
  ...Header,
  ...Shared,
  ...HomePage,
};

export default languageRUS;
